import { MeiliIndex, MeiliTrackData, MeiliArtistData, MeiliPlaylistData, SearchItem } from './types';
import { TRACK_PLACEHOLDER_ICON, ARTIST_PLACEHOLDER_ICON, PLAYLIST_PLACEHOLDER_ICON } from './consts';

export const mapTrackToSearchItem = (track: MeiliTrackData): SearchItem => {
  const { artistName, albumName } = track;

  // Create subtitle with both artist and album if available
  let subtitle = artistName;
  if (albumName && artistName) {
    subtitle = `${artistName} • ${albumName}`;
  } else if (albumName) {
    subtitle = albumName;
  }

  return {
    id: track.id,
    title: track.name,
    subtitle,
    placeholderIcon: TRACK_PLACEHOLDER_ICON,
    url: track.url,
    image: track.imageUrl,
    isImageRound: false,
    isImagePadding: true,
  };
};

export const mapArtistToSearchItem = (artist: MeiliArtistData): SearchItem => ({
  id: artist.id,
  title: artist.name,
  subtitle:
    artist.followers !== undefined && artist.followers > 0
      ? `${artist.followers.toLocaleString()} followers`
      : undefined,
  placeholderIcon: ARTIST_PLACEHOLDER_ICON,
  url: artist.url,
  image: artist.imageUrl,
  isImageRound: true,
  isImagePadding: false,
});

export const mapPlaylistToSearchItem = (playlist: MeiliPlaylistData): SearchItem => {
  const parts: string[] = [];
  if (playlist.curatorName !== undefined) {
    parts.push(playlist.curatorName);
  }
  if (playlist.songsCount !== undefined && playlist.songsCount > 0) {
    parts.push(`${playlist.songsCount} songs`);
  }
  if (playlist.followersCount !== undefined && playlist.followersCount > 0) {
    parts.push(`${playlist.followersCount.toLocaleString()} followers`);
  }

  return {
    id: playlist.id,
    title: playlist.name,
    subtitle: parts.length > 0 ? parts.join(' • ') : undefined,
    placeholderIcon: PLAYLIST_PLACEHOLDER_ICON,
    image: playlist.imageUrl,
    isImageRound: false,
    isImagePadding: true,
  };
};

export const getMapperFromMeiliResponse = (type: MeiliIndex) => {
  switch (type) {
    case MeiliIndex.tracks:
      return mapTrackToSearchItem;
    case MeiliIndex.artists:
      return mapArtistToSearchItem;
    case MeiliIndex.playlists:
      return mapPlaylistToSearchItem;
    default:
      throw new Error(`Unknown MeiliIndex type: ${type}`);
  }
};
